package ru.villawonka.app.presentation.screens.searchFilter.compose.view

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.theme.surfaceMiddle

@Composable
internal fun ColumnScope.CardView(
    content: @Composable () -> Unit
) {
    Column(
        modifier = Modifier
            .background(
                color = MaterialTheme.colors.surfaceMiddle,
            )
            .fillMaxWidth()
            .padding(
                vertical = 16.dp,
                horizontal = 16.dp,
            )
    ) {
        content()
    }
}